import React, { useContext, useEffect, useState } from 'react';
import { Container, Row, Col, Button, Form, Card, Carousel, Navbar, Nav } from "react-bootstrap";
import {  FaMapMarkedAlt , FaWhatsapp , FaPhoneAlt,FaArrowLeft,FaGlobe   } from "react-icons/fa";

import axios from 'axios';
import { site_url, site_url_img } from "./../config.js";
import "bootstrap/dist/css/bootstrap.min.css";
import "./styles.css";
import { useLocation } from 'react-router-dom';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { FaStar,FaUserCircle  } from "react-icons/fa";
import { format } from "date-fns";

function Index() {
    const location = useLocation();
    const shop = location.state?.shop;
    const [shopdetails, setshopdetails] = useState([]);
    const [rating, setRating] = useState(0);
    const [hover, setHover] = useState(0);
    const [userreview, setuserreview] = useState({ re_name: "", re_phone: "",re_desc: "",re_count:''}); 
    const [reviews, setReviews] = useState([]);


    useEffect(() => {
      const getproductlist = async () => {
        try {
  
          const response = await axios.get(site_url + '/vendor/getproductlist/'+shop.id);
  
          if (response.data.status == 'success') {
              console.log(response.data);
            setshopdetails(response.data.product);
            setReviews(response.data.review);
          }
        } catch (error) {
  
        }
      }
      getproductlist();
    },[shop.id]);
    const formSubmit = async (e) => {
      e.preventDefault();
      try {
          // Validate input fields
          if (!userreview.re_name || userreview.re_name.trim() === "") {
              alert("Please enter your name.");
              return;
          }
          if (!userreview.re_phone || userreview.re_phone.trim() === "") {
              alert("Please enter your phone number.");
              return;
          }
          if (!/^\d{10}$/.test(userreview.re_phone)) {
              alert("Please enter a valid 10-digit phone number.");
              return;
          }
          if (!userreview.re_desc || userreview.re_desc.trim() === "") {
              alert("Please enter your review description.");
              return;
          }
          if (!rating || rating < 1 || rating > 5) {
              alert("Please provide a valid rating between 1 and 5.");
              return;
          }
  
          // Prepare data for submission
          const data = {
              re_name: userreview.re_name,
              re_phone: userreview.re_phone,
              re_desc: userreview.re_desc,
              re_count: rating,
              sh_id:shop.id,
          };
  
          // Send request
          const response = await axios.post(site_url + "/vendor/reviewupdate", data);
  
          // Handle response
          if (response.data.status === "success") {
              console.log("Review submitted successfully:", response.data);
              alert("Review submitted successfully!");
              setuserreview({ re_name: "", re_phone: "", re_desc: "" }); // Reset form
              setRating(0);
          } else {
              alert("Failed to submit review. Please try again.");
          }
      } catch (error) {
          console.error("Error submitting review:", error);
          alert("An error occurred. Please try again later.");
      }
  };
  
  const handleCall = () => {
    window.open("tel:"+shop.phone,"_blank");
  };
  const handlewhatsappCall = () => {
    window.open("https://wa.me/"+shop.whatsapp_number,"_blank");
  };

  const handlelocation = () => {
    window.open("https://maps.google.com/?q=" + shop.latitude + "," + shop.longitude,"_blank");
  };
  const goBack = () => {
    window.history.back(); // Goes back to the previous page
  };
  const handlewebsiteurl = () => {
    window.open(shop.offer_text,"_blank");
  };
    return (
        <div className="min-vh-100">
            {/* Navbar */}
            <Navbar expand="lg" className="navbar px-3">

                <Navbar.Brand className="fw-bold text-white"><center><FaArrowLeft onClick={goBack} className="fs-5 text-white notificaton-icon" /> {shop?.shop_name}</center></Navbar.Brand>
                <Nav className="ms-auto d-flex align-items-center">
                </Nav>
            </Navbar>
            <Col xs={12} className="">
                <Card >
                    <Card.Body>
                        <center><img src={site_url_img + '/' + shop.shop_img} className="shoplist_img" /></center><br></br>
                        <b><span className="shoplist_text">{shop.shop_name}</span></b><br></br>
                        <span><b>Address:</b> {shop.address} </span><br></br><br></br>
                     <Button onClick={handleCall} variant="outline-primary"><FaPhoneAlt  className="fs-5 text-primary notificaton-icon" /> Call</Button> &nbsp;
                        <Button onClick={handlewhatsappCall} variant="outline-success"><FaWhatsapp   className="fs-5 text-success notificaton-icon" /> Whatsapp</Button>  &nbsp;
                        {shop.longitude && (
                        <Button onClick={handlelocation} variant="outline-info"><FaMapMarkedAlt className="fs-5 text-info notificaton-icon" /> Direction</Button> 
                        )}
                        {shop.offer_text && (
                        <Button className="mt-2" onClick={handlewebsiteurl} variant="outline-info"><FaGlobe className="fs-5 text-info notificaton-icon " /> Website</Button> 
                        )}
                    </Card.Body>
                    <Tabs
      defaultActiveKey="Product"
      id="justify-tab-example"
      className="mb-3"
      justify
    >
      <Tab eventKey="Product" title="Product">
      <div className="container mt-5">
  <div className="row justify-content-center">
  {shopdetails.map((shopdetails, index) => (
    <div className="col-4">
      <div className="shadow-sm" style={{marginBottom: '4%'}}>
        <img style={{width:'100%',height:'150px',padding:'8%'}} src={site_url_img + '/' + shopdetails.product_image} className="card-img-top" alt="Product Image" />
        <div className="card-body text-center">
          <h5 className="card-title">{shopdetails.product_name}</h5>
          <p style={{fontSize:'14px',fontWeight:'700'}} className="text-muted"><span class="badge badge-success">Best Price</span></p>
      
      
        </div>
      </div>
    </div>
       ))}
    
  </div>
</div>

      </Tab>
      <Tab eventKey="Review" title="Review">
    <form onSubmit={formSubmit}>
    <div className="text-center mt-1">
  <div>
        {[...Array(5)].map((_, index) => {
          const ratingValue = index + 1;
          return (
            <FaStar
              key={ratingValue}
              size={40}
              color={ratingValue <= (hover || rating) ? "gold" : "gray"}
              style={{ cursor: "pointer", marginRight: 5 }}
              onClick={() => setRating(ratingValue)}
              onMouseEnter={() => setHover(ratingValue)}
              onMouseLeave={() => setHover(0)}
            />
          );
        })}
      </div>
    </div>
  <div className="p-2">
    <label htmlFor="exampleInputEmail1">Name</label>
    <input type="text"  onChange={(e) => setuserreview({ ...userreview, re_name: e.target.value })} value={userreview.re_name}   required className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" />
  </div>
  <div className="p-2">
    <label htmlFor="exampleInputPassword1">Phone</label>
    <input type="number" onChange={(e) => setuserreview({ ...userreview, re_phone: e.target.value })} value={userreview.re_phone} required className="form-control" id="exampleInputPassword1"  />
  </div>
  <div className="p-2">
  <label for="exampleFormControlTextarea1">Description</label>
  <textarea 
  className="form-control" 
  id="exampleFormControlTextarea1" 
  rows="3"
  value={userreview.re_desc}  // Controlled value
  onChange={(e) => setuserreview({ ...userreview, re_desc: e.target.value })}
></textarea>
  </div>
  <center>
    <br></br>
    <button type="submit" className="btn btn-primary">
          Submit
        </button>
          </center>
</form>
<br>
</br>
{reviews.length === 0 ? (
        <p className="text-center">No reviews available.</p>
      ) : (
        <div className="row">
          {reviews.map((review, index) => {
            // Mask phone number (Show first 4 digits, hide last 6)
            const maskedPhone =
              review.re_phone?.substring(0, 4) + " ******";

            // Format date to "YYYY-MM-DD HH:mm:ss"
            const formattedDate = review.created_at
              ? format(new Date(review.created_at), "dd-MM-yyyy hh:mm aa")
              : "Unknown Date";

            return (
              <div key={index} className="col-md-6">
                <div className="card p-3 mb-3 shadow-sm">
                  <div className="card-body">
                    <div className="d-flex align-items-center">
                      <FaUserCircle size={40} className="me-2 text-secondary" />
                      <div>
                        <h5 className="card-title">{review.re_name}</h5>
                        <h6 className="text-muted">{maskedPhone}</h6>
                      </div>
                    </div>

                    <div className="mb-2">
                      {[...Array(5)].map((_, i) => (
                        <FaStar
                          key={i}
                          color={i < review.re_count ? "gold" : "gray"}
                          size={20}
                        />
                      ))}
                    </div>
                    <p className="card-text">{review.re_desc}</p>
                    <small className="text-muted">{formattedDate}</small>
                  </div>
                </div>
              </div>
            );
          })}
          </div>
      )}

      </Tab>
      <Tab eventKey="Location" title="Location">
        {(shop.map != null) ? (
      <div style={{width:'100%'}} dangerouslySetInnerHTML={{ __html: shop.map }} />
        ):(
            <div>
                <center><p>No Map Details</p></center>
            </div>
        )}
      </Tab>
      
    </Tabs>
                </Card>
            </Col>
        </div>
    )
}

export default Index